import React, { useState, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { Modal } from 'flowbite';

import ProcurementCategoriesSaveModal from './ProcurementCategoriesSaveModal';
import ProcurementCategoriesTableRow from './ProcurementCategoriesTableRow';

import { modalOptions } from 'Helpers/modalOptions';

import Button from 'CommonComponents/Button';
import ConfirmationModal from 'CommonComponents/ConfirmationModal';

import useModal from 'Hooks/useModal';

import PlusIcon from 'Assets/icons/plus.svg';

const queryParams = new URLSearchParams(window.location.search);
const query = { action: queryParams.get('action') };

export default function ProcurementCategoriesTable(props) {
    const [categories, setCategories] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [fetchUrl, setFetchUrl] = useState(props.indexUrl);
    const [updatedCategory, setUpdatedCategory] = useState({});
    const [deletedCategory, setDeletedCategory] = useState({});

    const [actionCompleted, setActionCompleted] = useState(false);
    const [actionInProgress, setActionInProgress] = useState(false);
    const [actionFailed, setActionFailed] = useState(false);

    const [procurementCategoriesDeleteModalElement, setProcurementCategoriesDeleteModalElement] = useState(null);

    const procurementCategoriesDeleteModalRef = useRef();

    const procurementCategoriesCreateModal = useModal({ visible: query.action === 'create_procurement_category' });
    const procurementCategoriesEditModal = useModal();

    useEffect(() => {
        fetchCategories();

        procurementCategoriesDeleteModalRef &&
            setProcurementCategoriesDeleteModalElement(new Modal(procurementCategoriesDeleteModalRef.current, modalOptions(false)));
    }, []);
    useEffect(() => {
        if (Object.keys(updatedCategory).length > 0) {
            procurementCategoriesEditModal.show();
        }
    }, [updatedCategory]);

    useEffect(() => {
        if (Object.keys(deletedCategory).length > 0) {
            procurementCategoriesDeleteModalElement && procurementCategoriesDeleteModalElement.show();
        }
    }, [deletedCategory]);

    const fetchCategories = () => {
        setIsLoading(true);
        axios
            .untranslated()
            .get(props.indexUrl)
            .then((res) => {
                setCategories([...res.data.categories]);
            })
            .catch((e) => {
                setCategories([]);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const addNewCategory = () => {
        procurementCategoriesCreateModal.show();
    };

    const editCategory = (category) => {
        setUpdatedCategory(category);
    };

    const deleteCategory = (category) => {
        setDeletedCategory(category);
    };

    const successHandler = () => {
        setUpdatedCategory({});
        setDeletedCategory({});
        fetchCategories();
        procurementCategoriesCreateModal.hide();
        procurementCategoriesEditModal.hide();
        procurementCategoriesDeleteModalElement && procurementCategoriesDeleteModalElement.hide();

        if (props.onChanged) {
            props.onChanged();
        }
    };

    const closeModal = () => {
        setUpdatedCategory({});
        setDeletedCategory({});
        procurementCategoriesCreateModal.hide();
        procurementCategoriesEditModal.hide();
        procurementCategoriesDeleteModalElement && procurementCategoriesDeleteModalElement.hide();
    };

    const cleanConfirmationModalStates = () => {
        setActionInProgress(false);
        setActionFailed(false);
        setActionCompleted(false);
    };

    const triggerDeleteCategory = () => {
        setActionInProgress(true);

        axios
            .delete(props.deleteUrl.replace('CATEGORY_ID', deletedCategory.id), { data: {} })
            .then((response) => {
                setActionCompleted(true);
            })
            .catch((e) => {
                setActionFailed(true);
            });
    };

    return (
        <div className="table__card">
            <div className="tw-flex tw-items-start tw-justify-between tw-mb-6">
                <h5 className="table__header">Procurement Categories</h5>
                <div>
                    <Button variant="primary" onClick={addNewCategory} disabled={isLoading}>
                        <PlusIcon className="tw-w-3 tw-h-3" />
                        Create Category
                    </Button>
                </div>
            </div>
            <div className="inbud-table_wrapper">
                <table className="inbud-table">
                    <thead>
                        <tr>
                            <th className="tw-w-44">Category Name</th>
                            <th>Additional Info </th>
                            <th className="tw-w-40">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {categories.map((category) => {
                            return (
                                <ProcurementCategoriesTableRow
                                    key={category.id}
                                    category={category}
                                    editCategory={editCategory}
                                    deleteCategory={deleteCategory}
                                />
                            );
                        })}
                    </tbody>
                </table>
            </div>

            <ProcurementCategoriesSaveModal
                id={'update-category'}
                modal={procurementCategoriesEditModal}
                closeHandler={closeModal}
                successHandler={successHandler}
                category={updatedCategory}
                updateUrl={props.updateUrl}
                action={'update'}
            />

            <ConfirmationModal
                closeHandler={closeModal}
                successHandler={successHandler}
                triggerAction={triggerDeleteCategory}
                cleanStates={cleanConfirmationModalStates}
                allowAction={Object.keys(deletedCategory).length > 0}
                modalId={'delete-category'}
                modalRef={procurementCategoriesDeleteModalRef}
                modalElement={procurementCategoriesDeleteModalElement}
                request={actionInProgress}
                actionCompleted={actionCompleted}
                actionFailed={actionFailed}
                confirmationMsg={'Are you sure you want to delete ' + [deletedCategory?.name]}
                actionCompletedMsg={[deletedCategory?.name] + ' deleted'}
                actionFailedMsg={[deletedCategory?.name] + ' could not be deleted'}
                title={'Delete Procurement Category'}
                cancelButtonText="Cancel"
                primaryButtonText="Delete"
            />

            <ProcurementCategoriesSaveModal
                id={'create-category'}
                modal={procurementCategoriesCreateModal}
                closeHandler={closeModal}
                successHandler={successHandler}
                category={{}}
                updateUrl={props.createUrl}
                action={'create'}
            />
        </div>
    );
}

if (document.getElementById('procurementCategoriesTable')) {
    var root = document.getElementById('procurementCategoriesTable');
    ReactDOM.render(
        <App>
            <ProcurementCategoriesTable
                indexUrl={categoriesIndexUrl}
                updateUrl={categoriesUpdateUrl}
                createUrl={categoriesCreateUrl}
                deleteUrl={categoriesDeleteUrl}
            />
        </App>,
        root,
    );
}
